import { Component, OnInit } from '@angular/core';
import { NotificationService } from '@app/notification-module/services/notification.service';
import { INotification } from '@app/notification-module/interfaces/notification.interface';
import { UnsubscribableComponent } from '@app/shared/unsubscribable/unsubscribable.component';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.css']
})
export class NotificationListComponent extends UnsubscribableComponent implements OnInit {
  public notifications: INotification[] = [];

  constructor(private _notificationService: NotificationService) {
    super();
  }

  ngOnInit() {
    this._notificationService.onNotify()
      .pipe(takeUntil(this._destroy$), filter(n => !this._notificationExist(n)))
      .subscribe((notification: INotification) => {
        this.notifications = [...this.notifications, notification];
      });
  }

  public removeNotification(notification: INotification): void {
    this.notifications = this.notifications.filter(n => n.id !== notification.id);
  }

  private _notificationExist(notification: INotification): boolean {
    if (!this.notifications.length) {
      return false;
    }

    return this.notifications.some(n => n.id === notification.id);
  }

}
